import React from 'react';
import LinkIcon from '@material-ui/icons/Link';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import TwitterIcon from '@material-ui/icons/Twitter';
import EmailIcon from '@material-ui/icons/Email';
import WebIcon from '@material-ui/icons/Web';
import PodcastIcon from '@material-ui/icons/Mic';
import LinkTreeIcon from './icons/LinkTreeIcon';
import TiktokIcon from './icons/TiktokIcon';

export const CUSTOM_LINK_PREFIX = 'aff';

export const ATTRIB_TYPE_ENUM_CUSTOM = 1;
export const ATTRIB_TYPE_ENUM_FACEBOOK = 2;
export const ATTRIB_TYPE_ENUM_INSTAGRAM = 3;
export const ATTRIB_TYPE_ENUM_LINKTREE = 4;
export const ATTRIB_TYPE_ENUM_YOUTUBE = 5;
export const ATTRIB_TYPE_ENUM_WEB = 6;
export const ATTRIB_TYPE_ENUM_EMAIL = 7;
export const ATTRIB_TYPE_ENUM_TWITTER = 8;
export const ATTRIB_TYPE_ENUM_TIKTOK = 9;
export const ATTRIB_TYPE_ENUM_PODCAST = 10;

export const ATTRIB_TYPE_ENUM_SLUGS = {
    [ATTRIB_TYPE_ENUM_CUSTOM]: null,
    [ATTRIB_TYPE_ENUM_FACEBOOK]: 'fb',
    [ATTRIB_TYPE_ENUM_INSTAGRAM]: 'ig',
    [ATTRIB_TYPE_ENUM_LINKTREE]: 'lt',
    [ATTRIB_TYPE_ENUM_YOUTUBE]: 'yt',
    [ATTRIB_TYPE_ENUM_WEB]: 'web',
    [ATTRIB_TYPE_ENUM_EMAIL]: 'email',
    [ATTRIB_TYPE_ENUM_TWITTER]: 'tw',
    [ATTRIB_TYPE_ENUM_TIKTOK]: 'tk',
    [ATTRIB_TYPE_ENUM_PODCAST]: 'pod'
};

export const ATTRIB_TYPE_ICON_COMPONENTS = {
    [ATTRIB_TYPE_ENUM_CUSTOM]: <LinkIcon />,
    [ATTRIB_TYPE_ENUM_FACEBOOK]: <FacebookIcon />,
    [ATTRIB_TYPE_ENUM_INSTAGRAM]: <InstagramIcon />,
    [ATTRIB_TYPE_ENUM_LINKTREE]: <LinkTreeIcon />,
    [ATTRIB_TYPE_ENUM_YOUTUBE]: <YouTubeIcon />,
    [ATTRIB_TYPE_ENUM_WEB]: <WebIcon />,
    [ATTRIB_TYPE_ENUM_EMAIL]: <EmailIcon />,
    [ATTRIB_TYPE_ENUM_TWITTER]: <TwitterIcon />,
    [ATTRIB_TYPE_ENUM_TIKTOK]: <TiktokIcon />,
    [ATTRIB_TYPE_ENUM_PODCAST]: <PodcastIcon />
};

export const PREDEFINED_ATTRIBS = [
    {
        typeLabel: 'Facebook',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_FACEBOOK],
        typeEnum: ATTRIB_TYPE_ENUM_FACEBOOK
    },
    {
        typeLabel: 'Instagram',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_INSTAGRAM],
        typeEnum: ATTRIB_TYPE_ENUM_INSTAGRAM
    },
    {
        typeLabel: 'Linktree',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_LINKTREE],
        typeEnum: ATTRIB_TYPE_ENUM_LINKTREE
    },
    {
        typeLabel: 'Website',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_WEB],
        typeEnum: ATTRIB_TYPE_ENUM_WEB
    },
    {
        typeLabel: 'Email',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_EMAIL],
        typeEnum: ATTRIB_TYPE_ENUM_EMAIL
    },
    {
        typeLabel: 'Twitter',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_TWITTER],
        typeEnum: ATTRIB_TYPE_ENUM_TWITTER
    },
    {
        typeLabel: 'Tiktok',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_TIKTOK],
        typeEnum: ATTRIB_TYPE_ENUM_TIKTOK
    },
    {
        typeLabel: 'Podcast',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_PODCAST],
        typeEnum: ATTRIB_TYPE_ENUM_PODCAST
    },
    {
        typeLabel: 'Youtube',
        typeSlug: ATTRIB_TYPE_ENUM_SLUGS[ATTRIB_TYPE_ENUM_YOUTUBE],
        typeEnum: ATTRIB_TYPE_ENUM_YOUTUBE
    }
];

export default {
    CUSTOM_LINK_PREFIX,
    ATTRIB_TYPE_ENUM_CUSTOM,
    ATTRIB_TYPE_ENUM_FACEBOOK,
    ATTRIB_TYPE_ENUM_INSTAGRAM,
    ATTRIB_TYPE_ENUM_YOUTUBE,
    ATTRIB_TYPE_ENUM_WEB,
    ATTRIB_TYPE_ENUM_EMAIL,
    ATTRIB_TYPE_ENUM_TWITTER,
    ATTRIB_TYPE_ENUM_TIKTOK,
    ATTRIB_TYPE_ENUM_PODCAST,
    ATTRIB_TYPE_ENUM_SLUGS,
    ATTRIB_TYPE_ICON_COMPONENTS,
    PREDEFINED_ATTRIBS
};
